function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect } from 'react';
import { isSameDay } from 'date-fns';
import { Controller, useFormContext } from 'react-hook-form';
import { KeyboardDatePicker, MenuItem, Select } from 'seagull';
import { BillMode } from "../BillClientModal.types";
import { getDefaultIssueDate, getMaxDateMessage, getMinDateMessage, normalizeEffectiveDate, selectorWidth } from "./BillingDate.utils";
import { useIssueDateValidation } from "./useIssueDateValidation";
import { useIoContext } from "../../../providers/IoContext";
import { connectControllerToKeyboardDatePicker } from "../../../utils/react-hook-form.utils";
import styles from "./BillingDate.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BillingDate = _ref => {
  let {
    billModeOptions,
    invoiceDateInfo,
    effectiveDate = null,
    earliestBillableDate
  } = _ref;
  const {
    getNow
  } = useIoContext();
  const {
    control,
    watch,
    setValue,
    trigger
  } = useFormContext();
  const [mode] = watch(['mode']);
  const {
    minDate,
    maxDate,
    validationRules
  } = useIssueDateValidation({
    mode,
    effectiveDate,
    earliestBillableDate
  });

  // force re-validation when mode changes to ensure Material-UI component updates its internal state and does not preserve the error state
  useEffect(() => {
    trigger('issueDate');
  }, [mode, trigger]);
  const onBillModeChange = value => {
    const newIssueDate = getDefaultIssueDate(value, invoiceDateInfo, getNow(), normalizeEffectiveDate(effectiveDate), earliestBillableDate);
    setValue('issueDate', newIssueDate, {
      shouldValidate: true
    });
  };
  const highlightDay = invoiceDateInfo && mode === BillMode.FutureDate ? day => invoiceDateInfo.invoiceDraftDates.dates().some(d => isSameDay(day, d)) : undefined;
  const dataTestId = mode === BillMode.FutureDate ? 'manual-bill-future-date' : 'manual-bill-issue-date';
  return /*#__PURE__*/_jsxs("div", {
    className: styles.modeRow,
    children: [/*#__PURE__*/_jsx(Controller, {
      control: control,
      name: 'mode',
      render: renderProps => /*#__PURE__*/_jsx(Select, {
        collapseHelperText: false,
        width: selectorWidth,
        value: mode,
        label: "Billing date",
        testid: "manual-bill-mode",
        children: billModeOptions.map(_ref2 => {
          let {
            value,
            text,
            disabled,
            tooltip
          } = _ref2;
          return /*#__PURE__*/_jsx(MenuItem, {
            value: value,
            disabled: disabled,
            tooltipProps: tooltip ? {
              placement: 'top',
              title: tooltip
            } : undefined,
            "data-testid": "mode-".concat(value),
            onClick: () => {
              onBillModeChange(value);
              renderProps.field.onChange(value);
            },
            children: text
          }, value);
        })
      })
    }), /*#__PURE__*/_jsx(Controller, {
      control: control,
      name: "issueDate",
      rules: validationRules,
      render: props => /*#__PURE__*/_jsx(KeyboardDatePicker, _objectSpread(_objectSpread({
        disabled: mode === BillMode.Upcoming,
        "data-testid": dataTestId,
        style: {
          width: selectorWidth
        },
        minDate: minDate,
        maxDate: maxDate,
        minDateMessage: getMinDateMessage(minDate),
        maxDateMessage: getMaxDateMessage(maxDate)
      }, connectControllerToKeyboardDatePicker(props)), {}, {
        highlightDay: highlightDay
      }))
    })]
  });
};
export default BillingDate;